module.exports = __webpack_public_path__ + "src/assets/img/share/tips/nervousness/ffcdfb581dd15d74cbec84ed621db63f.png";